// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-security-advisories-js": () => import("./../../../src/pages/security-advisories.js" /* webpackChunkName: "component---src-pages-security-advisories-js" */),
  "component---src-pages-security-advisory-legal-disclaimer-js": () => import("./../../../src/pages/security-advisory/legal-disclaimer.js" /* webpackChunkName: "component---src-pages-security-advisory-legal-disclaimer-js" */),
  "component---src-templates-security-advisories-js": () => import("./../../../src/templates/security-advisories.js" /* webpackChunkName: "component---src-templates-security-advisories-js" */)
}

